import React from 'react';
import { useNavigate } from 'react-router-dom';
import './explore.css';

const Explore = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/meetus1');
    };

    return (
        <button className='expbt' onClick={handleClick}>
            <h6 className='letstart'>Explore</h6>
            <div className='arrow'></div>
        </button>
    );
};

export default Explore;